var map = {
	"./arrow.svg": 5090,
	"./basket.svg": 3794,
	"./blue-arrow.svg": 9484,
	"./blue-phone.svg": 2190,
	"./blue-temperature.svg": 1562,
	"./blue-user.svg": 7879,
	"./calendar-blue.svg": 7149,
	"./calendar.svg": 874,
	"./clock.svg": 5997,
	"./close.svg": 420,
	"./closeselect.svg": 9914,
	"./comma.svg": 6739,
	"./delete.svg": 2539,
	"./dowload_ticket.svg": 7597,
	"./download-file.svg": 2723,
	"./edit.svg": 8377,
	"./email.svg": 7882,
	"./exit.svg": 3578,
	"./exit1.svg": 9908,
	"./eye.svg": 5564,
	"./file.svg": 1779,
	"./form/checkmark.svg": 2586,
	"./form/eye.svg": 3290,
	"./form/facebook.svg": 3161,
	"./form/google.svg": 7039,
	"./form/vk.svg": 8881,
	"./green-accordeon-arrow.svg": 9799,
	"./green-arrow.svg": 8097,
	"./header/gray-arrow.svg": 9815,
	"./img1.svg": 4600,
	"./img2.svg": 3494,
	"./img3.svg": 2913,
	"./img4.svg": 84,
	"./instagram.svg": 673,
	"./logo.svg": 3190,
	"./logo1.svg": 7207,
	"./logout.svg": 2990,
	"./logoutt.svg": 2130,
	"./map.svg": 5477,
	"./minus.svg": 4475,
	"./openselect.svg": 2036,
	"./payment/card.svg": 5104,
	"./payment/halyk.svg": 7905,
	"./payment/kaspi.svg": 3164,
	"./person.svg": 340,
	"./person1.svg": 4223,
	"./phone-white.svg": 7695,
	"./phone.svg": 9193,
	"./plus.svg": 3189,
	"./remove.svg": 4934,
	"./reviews/user-1.svg": 2946,
	"./reviews/user.svg": 6672,
	"./righttable1.svg": 4830,
	"./righttable2.svg": 6820,
	"./righttable3.svg": 1277,
	"./righttable4.svg": 3897,
	"./search.svg": 9262,
	"./selectclose.svg": 3616,
	"./social/instagram.svg": 2141,
	"./social/tiktok.svg": 5441,
	"./social/youtube.svg": 1646,
	"./success.svg": 4398,
	"./table.svg": 5846,
	"./table1.svg": 6494,
	"./table2.svg": 8685,
	"./table3.svg": 541,
	"./table4.svg": 5430,
	"./temperature.svg": 2155,
	"./title-icon-1.svg": 9140,
	"./title-icon-blue.svg": 2540,
	"./title-icon-dark-blue.svg": 9463,
	"./title-icon-green.svg": 4012,
	"./title-icon-light-blue.svg": 4420,
	"./title-icon-orange.svg": 3384,
	"./title-icon.svg": 9641,
	"./upload.svg": 377,
	"./user.svg": 1816,
	"./x.svg": 4118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;